import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { CTA, Icon, Modal, NoResult, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import { EventCard } from '../../../../app/pages/EventsList/style';
import routes from '../../../../routes';
import { timestampToDate } from '../../../../utils/common';
import { SESSIONS_LIST_RESET } from '../../../../app/redux/actions/events';

export const ModalEventsId = 'ModalEvents';

const Date = styled.div`
  padding-bottom: 16px;
  margin: 0 16px 16px;
  border-bottom: 1px solid #22408b;
`;

const ModalEvents = ({
  mediaIsPhone,
  id,
  isOpen,
  payload,
  sessions,
  modalClose,
  sessionListReset,
}) => {
  const scrollableAreaRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isOpen) sessionListReset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <Modal
      title="Eventi"
      modalId={ModalEventsId}
      scrollableAreaRef={scrollableAreaRef}
    >
      <Date>
        <Text type="b3">
          {dayjs(payload?.date)?.format('dddd, DD MMMM YYYY')}
        </Text>
      </Date>
      <ScrollableArea ref={scrollableAreaRef}>
        {sessions.length > 0 ? (
          sessions.map((item) => (
            <EventCard key={`card-event-${item.id}`}>
              <Text
                type="h3.5"
                className="title"
                mb={8}
                onClick={() =>
                  navigate(
                    `${routes.courseDetails.path}/${item.event_id}/panoramica`
                  )
                }
              >
                {item?.event_title}
              </Text>
              <Text type="b5" mb={8}>
                {item?.title}
              </Text>
              <div className="info">
                <div className="d-flex">
                  {timestampToDate(item?.start_time, 'HH:mm')}{' '}
                  <Icon type="clock" size={14} clickable={false} />
                </div>
                <div className="d-flex">
                  {item?.type === 'online'
                    ? 'Online'
                    : `${item?.city || 'In loco'}`}
                  <Icon type="marker-pin-01" size={14} clickable={false} />
                </div>
              </div>
            </EventCard>
          ))
        ) : (
          <NoResult text="Non sono presenti eventi in questa data." />
        )}
      </ScrollableArea>
      <Footer>
        <CTA
          type="secondary"
          btnText="Chidi"
          fullsize={mediaIsPhone}
          onClick={modalClose}
        />
      </Footer>
    </Modal>
  );
};

ModalEvents.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  id: PropTypes.string,
  isOpen: PropTypes.bool,
  payload: PropTypes.object,
  sessions: PropTypes.array,
  // dispatch
  modalClose: PropTypes.func.isRequired,
  sessionListReset: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { id, isOpen, payload } = state.app.modal;
      const { sessions } = state.events;
      return { id, isOpen, payload, sessions };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      sessionListReset: () => dispatch({ type: SESSIONS_LIST_RESET }),
    })
  ),
  withMediaQueries
)(ModalEvents);
